import { CalendarDate } from '@internationalized/date';
import { Statistic } from '@lucidtech/las-sdk-browser';

import { isNumber, safeDiv } from '@/utils';

export const DEFAULT_NUM_DAYS = 7;
export type MetricType = 'runs' | 'automation' | 'flagged' | 'edits' | 'fullAutomation';

export const createMetric = (num: number, total: number, previousNum: number, previousTotal: number) => {
  const value = safeDiv(num, total);
  const previousValue = safeDiv(previousNum, previousTotal);

  return {
    value,
    change: value - previousValue,
    datapoints: num,
  };
};

export const getData = (data?: Statistic | null) => {
  const numDocuments = isNumber(data?.documents) ? data.documents : 0;
  const numDocumentsAutomated = isNumber(data?.documentsAutomated) ? data.documentsAutomated : 0;
  const numValues = isNumber(data?.values) ? data.values : 0;
  const numValuesAutomated = isNumber(data?.valuesAutomated) ? data.valuesAutomated : 0;
  const numValuesDeleted = isNumber(data?.valuesDeleted) ? data.valuesDeleted : 0;
  const numValuesEdited = (isNumber(data?.valuesEdited) ? data.valuesEdited : 0) + numValuesDeleted;
  const numValuesFlagged = numValues - numValuesAutomated;

  return {
    numDocuments,
    numDocumentsAutomated,
    numValues,
    numValuesAutomated,
    numValuesEdited,
    numValuesFlagged,
    fractionDocumentsAutomated: safeDiv(numDocumentsAutomated, numDocuments),
    fractionValuesAutomated: safeDiv(numValuesAutomated, numValues),
    fractionValuesEdited: safeDiv(numValuesEdited, numValues),
    fractionValuesFlagged: safeDiv(numValuesFlagged, numValues),
  };
};

export const createDateRange = (days: number, anchor?: Date) => {
  const now = anchor ? anchor : new Date();
  const end = new CalendarDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
  now.setDate(now.getDate() - days);
  const start = new CalendarDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
  return { start, end };
};

export const statisticToName = {
  automation: 'Automation',
  fullAutomation: 'Straight through',
  flagged: 'Reviewed',
  edits: 'Corrected',
  runs: 'Runs',
};
